/**
 * Gallery Animation
 * Staggers appearance of gallery items on scroll
 */

export function initGalleryAnimation() {
  const galleryList = document.querySelector('.gallery10_list');
  const galleryItems = document.querySelectorAll('.gallery10_lightbox-link');
  
  if (galleryList && galleryItems.length) {
    gsap.timeline({
      scrollTrigger: {
        trigger: galleryList,
        start: "top 80%",
        end: "bottom 20%",
        toggleActions: "play none none reverse",
      }
    }).from(galleryItems, {
      opacity: 0,
      scale: 0.8,
      stagger: 0.2,
      duration: 1,
      ease: "power2.out"
    });
  }
}
